import React from "react";

import { titleToSlug } from "../../utils/generalLiveCenter";
import { DateUtility } from "../../utils/dateUtility";
import RaceCardItem from "../common/RaceCardItem";

const RaceCard = ({ weather, going, races, cnm, dt, sport, dataClient, dataPath, websiteBaseUrl }) => {
  return (
    <div className="race_cards">
      <div className="race_cards_hd">
        {going && <span className="cards_hd_lft">Going: {going}</span>}
        {weather && <span className="cards_hd_rgt">Weather: {weather}</span>}
      </div>
      <div className="race_cards_lst">
        {races?.map((race, index) => {
          const basePath = websiteBaseUrl || "";
          const pathSegment = dataPath || sport;
          const lnk = dataClient ? `${basePath}/${pathSegment}/race-cards/${titleToSlug(cnm)}/${DateUtility.ConvertDate1(dt)}/${race?.meeting_id}/${race?.id}/${titleToSlug(race?.nm)}` : '#';
          return <React.Fragment key={index}><RaceCardItem race={race} lnk={lnk} /></React.Fragment>;
        })}
      </div>
    </div>
  );
};

export default RaceCard;
